module.exports = __webpack_public_path__ + "h5/img/tabvip.bc6558e2.png";